// extracted by mini-css-extract-plugin
export default {"loading-box":"loading_loading-box__SjUQv"};